import { useRouteContext } from "@tanstack/react-router"
import type { UserFlags } from "@yomimono/types"

export function useUserFlags(): UserFlags | undefined {
  return useRouteContext({
    strict: false,
    select: (ctx) => ctx?.userFlags,
  })
}
